@if (loadingData) {
  <div class="spinner">
    <app-spinner class="mx-auto" size="lg"></app-spinner>
  </div>
}

@if (!((thingieCount$ | async) === 0)) {
  <div class="sticky-header">
    <div class="sticky-header-background-wrapper">
      <div class="sticky-header-background">
      </div>
    </div>

    <div class="grid-icon-container-wrapper">
      <mat-button-toggle-group (change)="changeMode($event)"
        class="grid-icon-container mat-button-toggle-group-icon mat-accent"
        [value]="viewMode">
        <mat-button-toggle value="cards">
          <ion-icon src="/assets/svg/grid-view.svg"></ion-icon>
        </mat-button-toggle>
        <mat-button-toggle value="thingies">
          <ion-icon src="/assets/svg/list-view.svg"></ion-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    
    <mat-tab-group
      #filterTabGroup
      class="tab-container"
      [@.disabled]="true"
      (selectedIndexChange)="onIndexSelected($event)"
      >
      @for (group of thingiesGroups; track group) {
        <mat-tab label="{{group.label}}" labelClass="{{group.labelClass}}">
          <ng-template mat-tab-label>
            <span [attr.data-cy]="group.dataCy">{{group.label}}</span>
          </ng-template>
          <ng-template matTabContent>
            @if (viewMode==='thingies') {
              <app-list-thingies-filter
                [pageSize]="pageSize"
                (callbackFunction)="paginationPageSizeCallbackFunction($event)"
                (filterCallbackFunction)="filterCallbackFunction($event)"
                [thingieGroups]="allThingies$ | async"
                [loadingData]="loadingData"
                [groupByExperimentChecked]="groupByExperimentChecked"
              ></app-list-thingies-filter>
            }
            @if (viewMode==='cards') {
              <app-thingie-card-view
                [groupByExperimentChecked]="groupByExperimentChecked"
                (callbackFunction)="paginationPageSizeCallbackFunction($event)"
                (groupByExperimentCallbackFunction)="groupByExperimentCallbackFunction($event)"
                (filterCallbackFunction)="filterCallbackFunction(RESET_ACTION)"
                [loadingData]="loadingData"
                [pageSize]="pageSize"
                [thingieGroups]="(allThingies$ | async) ?? []"
              ></app-thingie-card-view>
            }
          </ng-template>
        </mat-tab>
      }
    </mat-tab-group>
    
    @if (loadingData === false && showPagination === true) {
      <app-pagination
        [pageSize]="pageSize"
        [currentPage]="currentPage"
        [collectionSize]="collectionSize"
        (callbackFunction)="paginationCallbackFunction($event)"
      ></app-pagination>
    }
  </div>
} @else {
  <div class="no-thingie-wrapper">
    <div class="no-thingie-info">
      <div class="text-col">
        <div>
          <h2>
            Welcome to DOTS Software!
          </h2>
          <p>
            Create a new experiment to begin monitoring replicates within your lab.
            A replicate can be anything: a shake flask, a bioreactor, an incubator,
            or a flow loop.
          </p>
          <p>
            Click the Create button below to get started.
          </p>
        </div>
        <a
          id="action-button"
          mat-flat-button
          [disabled]="!isEditor()"
          [matTooltip]="!isEditor() ? 'You need to have editor permissions in at least one project to create an object.' : 'Create'"
          color="primary"
          [routerLink]="[urls.route.thingieCreate]"
          data-cy="dashboard__create_first_experiment_button"
        >
          <span class="inline-flex items-center">
            <ion-icon name="add-circle-outline"></ion-icon>
            <span>&nbsp;Create first experiment</span>
          </span>
        </a>
      </div>
      <div class="spacer"></div>
    </div>
  </div>
}
